import { render } from "./UploadImage.vue?vue&type=template&id=66463b74&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"

import "./UploadImage.vue?vue&type=style&index=0&id=66463b74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66463b74"

export default script